import { render, staticRenderFns } from "./ViewTagModal.vue?vue&type=template&id=401bb810&scoped=true"
import script from "./ViewTagModal.vue?vue&type=script&lang=ts"
export * from "./ViewTagModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401bb810",
  null
  
)

export default component.exports